import { INavLink, INavLinkGroup, INavProps, Nav, Panel, PanelType } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import { useResponsiveWindow } from "../hooks/useResponsiveWindow";
import { RootState } from "../redux/setupStore";
import { hideNavigationPanel } from "../redux/slices/appSlice";
import { NavStyles } from "../styles/themes";
import { currentEnvironment } from "../utils/environment";
import { isTdsa } from "../utils/Utils";

const NavigationMenu: React.FC<IReduxProps> = ({ navigationPanelIsVisible, hideNavigationPanel }) => {
  const history = useHistory();
  const { isLargeWindow } = useResponsiveWindow();

  const location = useLocation();
  const selectedLink = location.pathname.replace("/", "");

  const normalNavLinkGroup: INavLinkGroup = {
    links: [
      // title="" suppresses Fluent Nav's default title attribute (which mirrors the
      // link name) so screen readers don't announce each link twice.
      { name: "My Topologies", key: "MyTopologies", url: "/MyTopologies", title: "" },
      { name: "Create Topology", key: "NewTopology", url: "/NewTopology", title: "" },
      { name: "Resource Links", key: "ResourceLevels", url: "/ResourceLinks", title: "" },
      { name: "Support Links", key: "Support", url: "/Support", title: "" },
      { name: "Cloud Info", key: "CloudInfo", url: "/CloudInfo", title: "" },
    ],
  };

  /**
   * Since Queue Requests is still an experimental feature, we only
   * want to show the nav option in the STACKA version of the site.
   */
  if (isTdsa(currentEnvironment())) {
    const queueRequestsLink: INavLink = { name: "Queue Requests", key: "QueueRequests", url: "/QueueRequests", title: "" };

    normalNavLinkGroup.links.splice(1, 0, queueRequestsLink);
  }

  const onLinkClick: INavProps["onLinkClick"] = (ev?, item?) => {
    if (item) {
      history.push(item.url);

      hideNavigationPanel();
    }
  };

  useEffect(() => {
    if (isLargeWindow && navigationPanelIsVisible) {
      hideNavigationPanel();
    }
  }, [isLargeWindow, navigationPanelIsVisible, hideNavigationPanel]);

  return (
    <>
      <Panel
        styles={{ content: { padding: 0, paddingTop: 15 } }}
        headerText="TDS Web"
        isOpen={navigationPanelIsVisible}
        type={PanelType.smallFixedNear}
        onDismiss={() => hideNavigationPanel()}
        closeButtonAriaLabel="Close navigation menu"
      >
        <Nav
          selectedKey={selectedLink}
          ariaLabel="Main"
          groups={[normalNavLinkGroup]}
          onLinkClick={onLinkClick}
          styles={NavStyles}
        />
      </Panel>

      {isLargeWindow && (
        <Nav
          selectedKey={selectedLink}
          ariaLabel="Main"
          groups={[normalNavLinkGroup]}
          onLinkClick={onLinkClick}
          styles={NavStyles}
        />
      )}
    </>
  );
};

export const mapStateToProps = (state: RootState) => {
  return {
    navigationPanelIsVisible: state.appState.showNavigationPanel,
  };
};

export const mapDispatchToProps = {
  hideNavigationPanel,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type IReduxProps = ConnectedProps<typeof connector>;

export default connector(NavigationMenu);
